module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/brand-icons-13685372945d816a2b474fc082fd9aaa.ttf";